import React, { useState } from "react";
import { CustomButton } from "../UI/CustomButtons";
import styles from "../../_css/Home.module.css";
import {
  HOME_DATA_INFO_CARD,
  HOME_DATA_SESSION_DETAILS,
} from "../../data/staticDataHome";
import { useSelector, useDispatch } from "react-redux";
import VideoPlayer from "../Modals/VideoPlayer";
import StartChat from "../Modals/StartChat";
import ChatPopup from "../Modals/ChatPopup";
import VoiceChatPopup from "../Modals/VoiceChatPopup";
import {
  getSessionSummary,
  handleReview,
  resumeSession,
} from "../../requests";
import {
  deleteAuthToken,
  notifyError,
  notifySuccess,
} from "../../utils/helper";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { pdf } from "@react-pdf/renderer";
import AddReviewModal from "../Modals/AddReviewModal";
import { unlockAudioPlayback } from "../../utils/audioPlaybackManager";
import { prewarmMicForGesture } from "../../utils/micStreamManager";
import DownloadSummary from "../Modals/DownloadSummary";
import PDFGenerator from "../helper/PDFGenerator";
import { formatDate, isEnglishHtml } from "../helper/formatters";

function InfoCard({ title, description, image, avgRating, onReadMore, onStart, onPlay }) {
  const [showAddReviewModal, setShowAddReviewModal] = useState(false);
  const [showDownloadSummary, setShowDownloadSummary] = useState(false);
  const [pdfStatus, setPdfStatus] = useState(null);
  const [showStartChat, setShowStartChat] = useState(false);
  const [showChatPopup, setShowChatPopup] = useState(false);
  const [showVoicePopup, setShowVoicePopup] = useState(false);
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);


  const dispatch = useDispatch();

  const sessionData = sessionStorage.getItem("sessionData");
  const sessionDataParsed = JSON.parse(sessionData);

  const lang = useSelector((state) => state.language.lang);
  const { startText, readMoreText } = HOME_DATA_INFO_CARD[lang];
  const {
    pdfHeaderText,
    pdfFooterText,
    generatingPdfText,
    sendingRequestText,
    downloadedText,
    btnText,
  } = HOME_DATA_SESSION_DETAILS[lang];


  const onTextHandle = () => {
    setShowStartChat(false);
    setShowChatPopup(true);
  };
  const onVoiceHandle = () => {
    unlockAudioPlayback();
    prewarmMicForGesture();
    setShowStartChat(false);
    setShowVoicePopup(true);
  };

  const refreshReviews = () => {
    // fetchAllReviews();
  };

  const handleDownloadSummary = async () => {
    const userSessionId = sessionStorage.getItem("userSessionId");
    setPdfStatus(sendingRequestText);
    try {
      const response = await getSessionSummary({
        userSessionId,
      });
      const summary = response.data.message;
      const created_at = response.data.created_at;
      setPdfStatus(generatingPdfText);
      const isEnglish = isEnglishHtml(summary)
      const formattedDate = formatDate(created_at) || new Date().toISOString().split("T")[0];

      // Generate PDF
      const pdfDoc = (
        <PDFGenerator
          summary={summary}
          title={
            !isEnglish
              ? sessionDataParsed?.title_arabic
              : sessionDataParsed?.title || pdfHeaderText
          }
          pdfHeaderText={pdfHeaderText}
          pdfFooterText={"Generated on - " + formattedDate}
        />
      );

      // Create PDF blob
      const pdfBlob = await pdf(pdfDoc).toBlob();

      // Create download link
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `session-summary-${
        new Date().toISOString().split("T")[0]
      }.pdf`;

      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up
      URL.revokeObjectURL(url);

      setPdfStatus(downloadedText);
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      notifyError("Something went wrong");
    }

    refreshReviews();

    // check whether the review is added or not for a particular session
    // const review = reviewData.userReviews.find(review => review.user_session_id == userSessionId);

    // if (!review.review_id) {
    //   setShowAddReviewModal(true);
    // }

    setShowAddReviewModal(true);
    setShowDownloadSummary(false);
    setShowChatPopup(false);
    setShowVoicePopup(false);
  };

  const handleAddReview = async (review, ratings) => {
    if (!ratings) {
      notifyError("Please fill all the fields");
      return;
    }
    setShowAddReviewModal(false);
    dispatch(startLoader());
    const userSessionId = sessionStorage.getItem("userSessionId");
    try {
      const response = await handleReview({
        review: review,
        ratings: ratings,
        user_session_id: userSessionId,
      });
      if (response.status === 200) {
        // notifySuccess(response.data.message);
        notifySuccess(
          lang === "ar"
            ? "تمت إضافة التقييم بنجاح"
            : "Review added successfully"
        );
        // refreshReviews();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
      // Set pagination data from API response
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      // notifyError(error?.response?.data?.message);
      notifyError(
        lang === "ar" ? "فشل إضافة التقييم" : error?.response?.data?.message
      );
      console.error("Error in sending message:", error);
    }
    dispatch(stopLoader());
  };

  const handleResumeSession = async (isResume = false) => { 
    unlockAudioPlayback();
    prewarmMicForGesture();
    onStart();

    dispatch(startLoader());
    console.log("loader started..");

    sessionStorage.removeItem("resumeSessionData");
    sessionStorage.removeItem("chatHistory");

    setPdfStatus(null);

    const sessionData = sessionStorage.getItem("sessionData");
    const sessionDataParsed = JSON.parse(sessionData);
    const sessionId = sessionDataParsed?.id;

    const userSessionId = sessionStorage.getItem("userSessionId");

    try {
      const response = await resumeSession({
        sessionId: sessionId,
        userSessionId: userSessionId,
        isResume,
      });
      if (response.status === 200) {
        const { mode } = response.data.sessionInfo;

        // store session info
        sessionStorage.setItem(
          "resumeSessionData",
          JSON.stringify(response.data.sessionInfo)
        );
        const chatHistory = response.data.chatHistory;
        // store chat history
        sessionStorage.setItem("chatHistory", JSON.stringify(chatHistory));

        if (mode === "text") {
          setShowChatPopup(true);
        } else if (mode === "voice") {
          setShowVoicePopup(true);
        }
      } else if (response.status === 201) {
        setShowStartChat(true);
      } else if (response.status === 202) {
        notifyError(response.data.message[lang]);
      }
      // Set pagination data from API response
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      notifyError(error?.response?.data?.message);
      console.error("Error in sending message:", error);
    }
    dispatch(stopLoader());
  };

  const truncateHtmlText = (htmlString, charLimit = 10) => {
    if (!htmlString) return "";

    // Create a temporary DOM element to parse HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;

    // Get plain text without HTML tags
    const textContent = tempDiv.textContent || tempDiv.innerText || "";

    // If text is already within the limit, return it as is
    if (textContent.length <= charLimit) {
      return textContent;
    }

    // Truncate by character count
    const truncatedText = textContent.slice(0, charLimit).trim();

    // Add ellipsis to indicate truncation
    return truncatedText + "";
  };

  // on video play
  const handleVideoPlay = () => {
    onPlay();
    setShowVideoPlayer(true);
  };






  return (
    // <div className={styles.infoCard}>
    //   {image ? (
    //     <img
    //       src={image}
    //       alt="info-card"
    //       width="100%"
    //       className={styles.infoCardImage}
    //       onError={(e) => {
    //         e.target.src = `${process.env.REACT_APP_PROJECT_URL}/img/no-image.jpeg`;
    //       }}
    //     />
    //   ) : (
    //     <img
    //       src={`${process.env.REACT_APP_PROJECT_URL}/img/no-image.jpeg`}
    //       alt="info-card"
    //       width="100%"
    //       className={styles.infoCardImage}
    //     />
    //   )}
    //   <div className={styles.infoCardText}>
    //     <h6>{title}</h6>
    //     <p>{truncateHtmlText(description, 3)}</p>
    //     <CustomButton text={btnText} onClick={onReadMore} />
    //   </div>
    // </div>
    <>
      {
        // video player and start chat
        <div>
          <VideoPlayer
            show={showVideoPlayer}
            onHide={() => setShowVideoPlayer(false)}
            videoLink={
              lang === "ar"
                ? sessionDataParsed?.video_link_ar
                : sessionDataParsed?.video_link
            }
          />
          <StartChat
            show={showStartChat}
            onHide={() => setShowStartChat(false)}
            onTextHandle={onTextHandle}
            onVoiceHandle={onVoiceHandle}
          />
          <ChatPopup
            show={showChatPopup}
            onClose={() => setShowChatPopup(false)}
            setShowDownloadSummary={() => {
              setShowDownloadSummary(true);
              setShowChatPopup(false);
            }}
            header={
              lang === "ar"
                ? sessionDataParsed?.title_arabic
                : sessionDataParsed?.title
            }
            refreshReviews={refreshReviews}
            onDownload={handleDownloadSummary}
            pdfStatus={pdfStatus}
          />

          <VoiceChatPopup
            show={showVoicePopup}
            onClose={() => setShowVoicePopup(false)}
            setShowDownloadSummary={() => {
              setShowDownloadSummary(true);
              setShowVoicePopup(false);
            }}
            header={
              lang === "ar"
                ? sessionDataParsed?.title_arabic
                : sessionDataParsed?.title
            }
            refreshReviews={refreshReviews}
            onDownload={handleDownloadSummary}
            pdfStatus={pdfStatus}
          />

          <AddReviewModal
            show={showAddReviewModal}
            onHide={() => setShowAddReviewModal(false)}
            onSubmit={handleAddReview}
            btnText={btnText}
          />
          <DownloadSummary
            show={showDownloadSummary}
            onHide={() => {
              setShowAddReviewModal(true);
              setShowDownloadSummary(false);
            }}
            onDownload={handleDownloadSummary}
            pdfStatus={pdfStatus}
          />
        </div>
      }
      <div
        className={`${styles.infoCard2} ${
          lang === "ar" ? styles.infoCard2_rtl : ""
        }`}
      >
        <div className={styles.infoCard2Image}>
          {image ? (
            <img
              src={image}
              alt="info-card"
              className={styles.infoCard2ImageImg}
              onError={(e) => {
                e.target.src = `${process.env.REACT_APP_PROJECT_URL}/img/no-image.jpeg`;
              }}
            />
          ) : (
            <img
              src={`${process.env.REACT_APP_PROJECT_URL}/img/no-image.jpeg`}
              alt="info-card"
              className={styles.infoCard2ImageImg}
            />
          )}
        </div>
        <div
          className={`${styles.infoCard2Text} ${
            lang === "ar" ? styles.infoCard2Text_rtl : ""
          }`}
        >
          <div className={styles.infoCard2TextTitle}> {title} </div>
          <div className={styles.infoCard2TextDescription}>
            {" "}
            {truncateHtmlText(description, 14)}
            {".."}
            <span
              style={{
                color: "#1e5ca8",
                cursor: "pointer",
                textDecoration: "underline",
                textDecorationThickness: "1px",
                textUnderlineOffset: "2px",
              }}
              onClick={onReadMore}
            >
              {readMoreText}
            </span>
          </div>
          <div className={styles.infoCard2TextButtonContainer}>
            <CustomButton
              text={startText}
              onClick={() => {
                handleResumeSession();
              }}
              padding="4px 12px"
            />
            <img
              src={`${process.env.REACT_APP_PROJECT_URL}/img/newPlayLogo.PNG`}
              alt="arrow-right"
              onClick={handleVideoPlay}
            />
          </div>
          <div
            className={styles.starRatingContainer}
            dir={lang === "ar" ? "rtl" : "ltr"}
          >
            {avgRating !== undefined && avgRating !== null ? (
              <>
                {[1, 2, 3, 4, 5].map((star) => {
                  const filledPercentage = Math.max(0, Math.min(100, ((avgRating - (star - 1)) * 100)));
                  return (
                    <span key={star} className={styles.starWrapper}>
                      <span
                        className={styles.starFilled}
                        style={{
                          width: `${filledPercentage}%`,
                        }}
                      >
                        ★
                      </span>
                      <span className={styles.starEmpty}>★</span>
                    </span>
                  );
                })}
                
              </>
            ) : (
              <span className={styles.noRatingsText}>
                {lang === "ar" ? "لم يتم التقييم" : "No ratings yet"}
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default InfoCard;
